export const tagsInputIpFieldMessages = {
  en: {
    invalidEntriesRemoved: 'Invalid entries were removed',
  },
};
